import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EuiListComponent } from './eui-list.component';
import { EuiListItemComponent } from './eui-list-item/eui-list-item.component';
import { EuiIconModule, EuiLabelModule } from '../atoms';
import { EuiButtonModule } from '../eui-button';
import { EuiListService } from './services/eui-list.service';

@NgModule({
    imports: [
        CommonModule,
        EuiIconModule,
        EuiButtonModule,
        EuiLabelModule,
    ],
    declarations: [
        EuiListComponent,
        EuiListItemComponent,
    ],
    exports: [
        EuiListComponent,
        EuiListItemComponent,
    ],
    providers: [
        EuiListService,
    ],
})
export class EuiListModule { }
